import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import FormGroup from '@/components/templates/FormGroup';
import MultiError from '@/components/templates/MultiError';
import VueLogger from 'vuejs-logger';
import errorResponseHandler from "@/services/errorResponseHandler";
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import VueKeyCloak from '@/plugins/keycloak-plugin';
import Axios from '@/plugins/axios-plugin';
import { store } from './store/store'
import money from 'v-money'
import vSelect from 'mdh-vue-select'

//import VueBrowserUpdate from '@sum.cumo/vue-browserupdate';
//import Es6Promise from 'es6-promise'
//Es6Promise.polyfill()

//Vue.use(VueBrowserUpdate, {
//  options: {
//  required:{
//    e:16,
//    i:12,
//    f:58,
//    o:51,
//    o_a:45,
//    s:-1,
//    c:"67.0.3396.12",
//    y:18.1,
//    v:"1.10",
//    uc:11.5,
//    samsung:7.0
//}}
//});

Vue.config.productionTip = false
Vue.use(Vuelidate)

Vue.component('v-select', vSelect)

Vue.use(VuelidateErrorExtractor, {
  i18n: false,
  template: FormGroup,
  messages: {
    required: "{attribute} is required.",
    email: "{attribute} is not a valid Email Address.",
    isDivisionValid: "{attribute} is not valid.",
    numeric: "{attribute} must be a numeric value.",
    decimal: "{attribute} must be a numeric value.",
    checked: "{attribute}",
    minDate: "{attribute} must be after start date.",
    maxDate: "{attribute} must be in the past.",
    maxLength: "{attribute} has exceeded its maximum length.",
    minLength: "{attribute} must meet its minimum length.",
    tbdValidator: "{attribute} must not contain 'TBD'."
  },
  attributes: {
    'request.hoursPerWeek': 'Hours Per Week',
    'divDirector.approver.userId': 'Division Director',
    'asstCommissioner.approver.userId': 'Assistant Commissioner',
    'request.divDirector.approver.userId': 'Division Director',
    'request.asstCommissioner.approver.userId': 'Assistant Commissioner',
    'request.positionNumber': 'Position Number',
    'request.proposedClassification': 'Proposed Classification',
    'request.workingHours': 'Working Hours',
    'request.division': 'Division',
    'request.supervisor.userId': 'Supervisor',
    'request.anticipatedStartDate': 'Anticipated Start Date',
    'request.funding': 'Position Funding',
    'request.positionLocation': 'Work Location',
    'request.departmentId': 'Department ID',
    'request.unitName': 'Unit Name',
    'request.positionStatusValue.code': 'Position Status',
    'request.positionScheduleValue.code': 'Position Schedule',
    'request.appointmentValue.code': 'Appointment Type',
    'request.positionClassificationValue.code': 'Position Classification',
    'request.workScheduleValue.code': 'Work Schedule',
    'request.workTravelValue.code': 'Travel Requirement',
    'haveAllAttachments': 'One or more required attachments are missing',
    'totalFundingStringPercent': 'All funding strings totalling 100%',
    'checklistComplete': 'All checklist items must be checked.',
    'tbdValidator': 'Funding Strings should not contain \'TBD\'',
    'request.jobId': 'Recruiting Solutions Job ID',
    'request.funding.fundingPercent': 'Funding String - Percent',
    'request.funding.fundId': 'Funding String - Fund ID',
    'request.funding.divisionId': 'Funding String - Division ID',
    'request.funding.sourceType': 'Funding String - Source',
    'request.funding.appropriationId': 'Funding String - Appropriation ID',
    'request.funding.project': 'Funding String - Project',
    'request.funding.activity': 'Funding String - Activity',  
    'funding.fundingPercent': 'Funding String - Percent',
    'funding.fundId': 'Funding String - Fund ID',
    'funding.divisionId': 'Funding String - Division ID',
    'funding.sourceType': 'Funding String - Source',
    'funding.appropriationId': 'Funding String - Appropriation ID',
    'funding.project': 'Funding String - Project',
    'funding.activity': 'Funding String - Activity',  
    'setting.ics_approver_1': 'ICS Approver #1',
    'setting.ics_approver_2': 'ICS Approver #2',
    'setting.ics_approver_3': 'ICS Approver #3',
    'setting.ics_hrm_1': 'ICS HRM Staffing Specialist #1',
    'setting.ics_hrm_2': 'ICS HRM Staffing Specialist #2',
    'setting.ics_hrm_3': 'ICS HRM Staffing Specialist #3',
    'request.endDate': 'End Date',
    'request.offerAcceptanceDate': 'Offer Acceptance Date',
    'request.contingentOfferMadeDate': 'Contingent Offer Made Date',
    'request.rate': 'Rate',
    'request.salaryReviewSupervisorDate': 'Date Salary Review Sent to Hiring Supervisor',
    'request.flsaStatusValue': 'FLSA Status',
    'request.selectedCandidateEmployeeId': 'Selected Employee ID',
    'request.currentClassification': 'Current/Former Classification',
    'request.currentCompCode': 'Current/Former Comp Code',
    'request.currentStep': 'Current/Former Step',
    'request.currentRate': 'Current/Former Rate',
    'request.reports.count': 'Direct Report Count',
    'request.reports.empCondition': 'Direct Report Employment Condition',
    'request.reports.classification': 'Direct Report Classification',

    'request.eligibilityNextProgressIncreaseDate': 'Date of Eligibility for Next Progression Increase',
    'request.recommendedSalaryWithinDDDelegation': 'Is the recommended salary within division director delegation',
    'request.hrInternalEquityComparisonAnalysis': 'HR Internal Equity and comparison Analysis',
    'request.approvedSalaryRecommendation': 'Approved Salary Recommendation',
    'request.approvedStep': 'Approved Step',
    'request.approvedRate': 'Approved Rate',
    'request.approvedAmountOfChangeUom': 'Approved Amount of Change UOM',
    'request.approvedAmountOfChange': 'Approved Amount of Change',
    'request.salaryApprovalComments': 'Salary Approval Comments',
    'request.postingOpenDate': 'Posting Open Date',
    'request.postingCloseDate': 'Posting Close Date',
    'request.howPosted': 'How was posting posted',
    'request.offerMethod': 'Offer Method',
    'request.offerNextStep': 'Offer Next Step',
    'request.offerDeclineReason': 'Offer Decline Reason',
    'request.offerOutcome': 'Offer Decision',

    'request.vacationElig': 'Vacation Eligibility',
    'request.vacationHours': 'Vacation Payout Amount',
    'request.vacationPayoutType': 'Vacation Payout Type',
    'request.severancePayout': 'Severance Payout Amount',
    'request.healthCareRetirement': 'Health Care Retirement',
    'request.compPayout': 'Comp Payout',
    'request.removeSick': 'Remove Sick',
    'request.severanceElig': 'Severance Eligibility',
    'removeRights': 'Have Approval Rights been Removed',
    'request.salaryComments': 'Salary Comments'
  }
});

Vue.component('form-summary', MultiError)

const options = {
  isEnabled: true,
  logLevel : Vue.config.productionTip  ? 'error' : 'debug',
  stringifyArguments : false,
  showLogLevel : true,
  showMethodName : true,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, options);
Vue.use(Axios)

Vue.use(VueKeyCloak, {
  init: {
    onLoad: 'check-sso',
    checkLoginIframe: false
  },
  config: {
    url: `${process.env.VUE_APP_KEYCLOAK_URL}`,
    clientId: `${process.env.VUE_APP_KEYCLOAK_CLIENT}`,
    realm: `${process.env.VUE_APP_KEYCLOAK_REALM}`,
    logoutRedirectUri: `${process.env.VUE_APP_KEYCLOAK_LOGOUT_REDIRECT_URI}`
  },
  onReady: kc => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})

const requireComponent = require.context(
  './components',
  false,
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
    camelCase(
      fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    )
  )

  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
}) 